import React from 'react';
import { Table, Tag, Button } from 'antd';
import { WarningOutlined, EditOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { formatDate } from '@utils/dateTime';

export default function ReturnReceiptItemsTable({ items, highlightedItemId, onItemClick }) {
  const { t } = useTranslation();

  const columns = [
    {
      title: t('models.product.name', { defaultValue: '商品' }),
      key: 'product',
      render: (_, record) => (
        <div>
          <div style={{ fontWeight: 500 }}>{record.product?.name}</div>
          <div style={{ fontSize: 12, color: '#999' }}>{record.product?.sku}</div>
        </div>
      ),
    },
    {
      title: t('models.return_receipt_item.inventory_type'),
      key: 'inventory_type',
      render: (_, record) => record.inventory_type?.name || '-',
    },
    {
      title: t('models.return_receipt_item.batch'),
      dataIndex: 'batch',
      key: 'batch',
      render: (text) => text || '-',
    },
    {
      title: t('models.return_receipt_item.expiration_date'),
      dataIndex: 'expiration_date',
      key: 'expiration_date',
      render: (text) => text ? formatDate(text) : '-',
    },
    {
      title: t('operator.return_verification.received_expected', { defaultValue: '實收 / 預期' }),
      key: 'quantity',
      align: 'right',
      render: (_, record) => {
        const expected = record.quantity || 0;
        const received = record.received_quantity || 0;
        const hasDiscrepancy = received !== expected && expected > 0;
        const isUnplanned = !!record.unplanned;

        return (
          <div style={{ textAlign: 'right' }}>
            <span style={{ color: hasDiscrepancy ? '#ff4d4f' : '#000', fontWeight: hasDiscrepancy ? 500 : 400 }}>
              {received}
            </span>
            {!isUnplanned && (
              <>
                <span style={{ color: '#999', margin: '0 4px' }}>/</span>
                <span style={{ color: '#666' }}>{expected}</span>
              </>
            )}
          </div>
        );
      },
    },
    {
      title: '',
      key: 'status',
      width: 80,
      render: (_, record) => {
        if (record.unplanned) return <Tag color="orange">{t('operator.return_verification.unplanned', { defaultValue: '非預期' })}</Tag>;
        if (record.mismatch) return <WarningOutlined style={{ color: '#faad14' }} />;
        if (record.received_quantity > 0) return <Tag color="green">{t('operator.return_verification.verified', { defaultValue: '已驗' })}</Tag>;
        return null;
      },
    },
    {
      title: '',
      key: 'action',
      width: 50,
      render: (_, record) => (
        <Button
          type="text"
          size="small"
          icon={<EditOutlined />}
          onClick={(e) => {
            e.stopPropagation();
            onItemClick?.(record);
          }}
        />
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={items}
      rowKey="id"
      pagination={false}
      size="small"
      rowClassName={(record) => record.id === highlightedItemId ? 'highlighted-row' : ''}
    />
  );
}
